import { ResourceInIncident } from '../../hooks/resourceInIncidentHooks';
import { KanbanCard } from '../../../DesignSystems/Kanban';

/**
 * Create a kanban card from a resource
 *
 * @param resource - The resource to create a card from
 * @returns KanbanCard object
 */
export const createResourceCard = (
  resource: ResourceInIncident
): KanbanCard => ({
  id: resource.id,
  title: resource.resource_name || 'Unknown Resource',
  description: `${resource.resource_type || 'Unknown Kind'} - Qty: ${
    resource.resource_set_quantity || resource.personnel_count || 1
  }`,
  metadata: resource,
});
